import AttachmentsScreen from './AttachmentsScreen';

export default AttachmentsScreen;
